import type {CommunicationEvent} from '../../shared/delivery-activity';

// Presentation only: preserve all event identities and chronology. Group only
// adjacent routine saves on the same displayed calendar day; never cross a
// payment, issue, send, revision or other historical event.
export function groupRoutineDraftSaves(events: readonly CommunicationEvent[]) {
  const groups: CommunicationEvent[][] = [];
  for (const event of [...events].reverse()) {
    const previous = groups.at(-1);
    if (event.kind === 'draft_saved' && previous?.[0]?.kind === 'draft_saved'
      && new Date(event.created_at).toDateString() === new Date(previous[0].created_at).toDateString()) previous.push(event);
    else groups.push([event]);
  }
  return groups;
}
